import { render, staticRenderFns } from "./packageNumber.vue?vue&type=template&id=7049aafe&scoped=true"
import script from "./packageNumber.vue?vue&type=script&lang=js"
export * from "./packageNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7049aafe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7049aafe')) {
      api.createRecord('7049aafe', component.options)
    } else {
      api.reload('7049aafe', component.options)
    }
    module.hot.accept("./packageNumber.vue?vue&type=template&id=7049aafe&scoped=true", function () {
      api.rerender('7049aafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/preLoadTruckPickup/packageNumber.vue"
export default component.exports